import { useABTesting } from './abTesting';
import { CurrencyCode } from '@/helpers/currency';
import { groupMemberAUD100, groupMemberNoDeposits } from '@/helpers/user';
import { useCommonStore } from '@/store';

export enum ExpReducedPresetAUDLU {
  A = 'a_default_preset_50AUD_lu',
  B = 'b_decr_preset_25AUD_lu',
}

export const useIsExpReducedPresetAUDLU = () => {
  const user = useCommonStore.use.user();
  const pendingUser = useCommonStore.use.pendingUser();

  const version = useABTesting('exp_reduced_preset_aud_lu', {
    defaultVersion: ExpReducedPresetAUDLU.A,
    versions: [
      { name: ExpReducedPresetAUDLU.A, probability: 50 },
      { name: ExpReducedPresetAUDLU.B, probability: 50 },
    ],
    turnOffTest:
      pendingUser ||
      !user ||
      user.currency !== CurrencyCode.AUD ||
      !groupMemberNoDeposits(user) ||
      groupMemberAUD100(user),
  });

  return version === ExpReducedPresetAUDLU.B;
};
